import { State } from "./types"

export const createInitialState = (): State => {
  return {
    currentCulture: "sv-SE",
    miniCart: {
      enabled: false,
      open: false,
      showItemsAdded: false,
    },
    selectedProducts: [],
    passHolderDetails: [],
    hasArrivalDateBeenSet: false,
  }
}
